import { useOpenReport } from "@/hooks/use-open-report";
import { RecentReportsSection } from "./recent-reports-section";
import { useRecentReports } from "./use-recent-reports";

/** 최근 수정한 DSD 워크북로 노출할 개수 */
const RECENT_LIMIT = 3;

// ============================================
// RecentReportsContainer
// 최근 수정된 보고서 상위 N개를 조회해 RecentReportsSection에 주입한다.
// ============================================

export const RecentReportsContainer = () => {
  const openReport = useOpenReport();
  const { reports, isAuthorLoading } = useRecentReports(RECENT_LIMIT);

  // 보고서가 하나도 없으면 최근 섹션은 숨긴다 (목록의 빈 상태가 안내를 담당).
  if (reports.length === 0) return null;

  return (
    <RecentReportsSection
      reports={reports}
      isAuthorLoading={isAuthorLoading}
      onSelect={openReport}
    />
  );
};
